import React, { useContext } from 'react';
import './Center.css';
import { LanguageContext, getTranslation } from '../LanguageContext';
import { FaMapMarkerAlt, FaHome, FaChild } from 'react-icons/fa';

// Objeto de traducciones para el componente Center
const centerTranslations = {
  en: {
    centerTitle: "Al-Amal Center for abandoned children care, Settat",
    centerDescription: "Located in Settat, the Al-Amal Center provides a warm home for abandoned infants. From birth to five years, children receive comprehensive care, combining medical care, education, and stimulation. The center's multidisciplinary team is committed to offering each child a personalized journey, thus promoting their development and preparation for the future."
  },
  fr: {
    centerTitle: "Centre Al-Amal pour la prise en charge des enfants abandonnés, Settat",
    centerDescription: "Situé à Settat, le Centre Al-Amal offre un foyer chaleureux aux tout-petits abandonnés. De la naissance à cinq ans, les enfants bénéficient d'une prise en charge globale, alliant soins médicaux, éducation et éveil. L'équipe pluridisciplinaire du centre s'engage à offrir à chaque enfant un parcours personnalisé, favorisant ainsi son épanouissement Et sa préparation a affronter l'avenir."
  },
  ar: {
    centerTitle: "مركز الأمل لرعاية الأطفال المتخلى عنهم، سطات",
    centerDescription: "يقع مركز الأمل في سطات ويوفر منزلاً دافئاً للأطفال الصغار المتخلى عنهم. من الولادة وحتى سن الخامسة، يتلقى الأطفال رعاية شاملة تجمع بين الرعاية الطبية والتعليم والتحفيز. يلتزم فريق المركز متعدد التخصصات بتقديم رحلة مخصصة لكل طفل، مما يعزز نموهم وتحضيرهم للمستقبل."
  }
};

const Center = () => {
    // Usar el contexto de idioma
    const { language } = useContext(LanguageContext);
    
    // Función para obtener la traducción
    const translate = (key) => getTranslation(centerTranslations, language, key);
    
    // Determinar si el texto debe fluir de derecha a izquierda (para árabe)
    const isRTL = language === 'ar';
    
    return (
        <div className={`profile-card ${isRTL ? 'rtl' : ''}`}>
            <div className="profile-image">
                <img 
                    src="https://firebasestorage.googleapis.com/v0/b/anpe-24524.appspot.com/o/ANPE%2FWhatsApp%20Image%202024-08-09%20at%2011.41.16_f016c7f4.jpg?alt=media&token=94dccfd6-53aa-4d8d-bbf7-06b8f79dd574" 
                    alt={translate('centerTitle')} 
                    aria-label="Al-Amal Center"
                />
            </div>
            <div className="profile-content">
                <h2>
                    <span className="icon-wrapper">
                        <FaHome className="center-icon" />
                    </span>
                    {translate('centerTitle')}
                </h2>
                <p>
                    <span className="icon-wrapper">
                        <FaChild className="center-icon" />
                    </span>
                    {translate('centerDescription')}
                </p>
                <div className="map-container">
                    <span className="map-header">
                        <FaMapMarkerAlt className="center-icon" />
                    </span>
                    <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d861.4602638808176!2d-7.613554610711629!3d33.01310912293288!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzPCsDAwJzQ3LjIiTiA3wrAzNic1MS4xIlc!5e1!3m2!1sar!2sma!4v1723195418399!5m2!1sar!2sma" 
                        height="250" 
                        allowFullScreen=""
                        loading="lazy" 
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Google Maps Location"
                        aria-label="Center location on map"
                    ></iframe>
                </div>
            </div>
        </div>
    );
};

export default Center;
